import { z } from 'zod';
import { featureFlagSchema, featureFlagTargetingSchema, flagKeySchema, } from '../schemas/feature-flag.js';
import { listQueryBase, paginatedResponse } from './_shared.js';
/**
 * `GET /api/flags` — paginated list. Gate `flags:view`. Pre-migration the
 * route returned a bare array; this contract switches it to the canonical
 * paginated shape so the Flags admin tab renders. `sort` is a signed
 * comma-joined field list validated server-side against the whitelist
 * (`key`, `enabled`, `updatedAt`). `enabled` filters to only enabled or
 * only disabled flags.
 */
export const listFlagsQuerySchema = listQueryBase.extend({
    search: z.string().min(1).max(200).optional(),
    enabled: z.enum(['true', 'false']).optional(),
});
/**
 * `GET /api/flags/export` — same filters + sort as the list, without
 * pagination. Used to stream all matching rows as a `text/csv` attachment.
 */
export const exportFlagsQuerySchema = listFlagsQuerySchema.omit({
    page: true,
    pageSize: true,
});
export const listFlagsResponseSchema = paginatedResponse(featureFlagSchema);
export const flagKeyParamSchema = z.object({ key: flagKeySchema });
/**
 * `PUT /api/flags/:key` body — full replacement. Gate `flags:update`. Key
 * lives in the path; body is identical to create minus `key`.
 */
export const updateFlagBodySchema = z
    .object({
    description: z.string().max(512).nullable().optional(),
    enabled: z.boolean(),
    value: z.unknown().optional(),
    targetingRules: featureFlagTargetingSchema.nullable().optional(),
})
    .strict();
export const updateFlagResponseSchema = featureFlagSchema;
// `DELETE /api/flags/:key` reuses `flagKeyParamSchema` directly — no
// dedicated `deleteFlagParamsSchema` is exported because the registry
// references the shared param schema (see `openapi/registry.ts` flags
// block). Audit action `flag.deleted`, returns 204.
//# sourceMappingURL=flags.js.map